import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

import { useIsSalesDirector } from '@/store/auth.store';

const TABS = [
  { to: '/establishments', label: 'Заведения' },
  { to: '/suppliers', label: 'Поставщики' },
  { to: '/wholesalers', label: 'Оптовики' },
] as const;

/**
 * Клиенты платформы у руководителя на телефоне: в нижней панели пять вкладок
 * уже заняты, поэтому поставщики и оптовики — переключателем над списком.
 * На компьютере они в боковом меню.
 */
export default function ClientsTabs() {
  const isDirector = useIsSalesDirector();
  if (!isDirector) return null;
  return (
    <nav className="grid grid-cols-3 gap-1 rounded-xl bg-ink/5 p-1 md:hidden" aria-label="Клиенты">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            clsx(
              'flex min-h-[40px] items-center justify-center rounded-lg px-2 text-sm font-medium',
              isActive ? 'bg-white text-ink shadow-sm' : 'text-ink/60',
            )
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
